import { OidcConfiguration } from "@axa-fr/react-oidc";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { IdpConfiguration, OidcAppConfiguration, OidcContext, OidcPath } from "../types/oidcTypes";
import { createRedirectUri } from "./oidcUtils";

export function getIdpConfiguration(oidcContext: OidcContext): IdpConfiguration {
  switch (oidcContext) {
    case OidcContext.DEFAULT:
      return {
        authority: environment.NX_OIDC_AUTHORITY,
        client_id: environment.NX_OIDC_CLIENT_ID,
        scope: environment.NX_OIDC_SCOPES,
      };
    case OidcContext.TVM:
      return {
        authority: environment.NX_TVM_OIDC_AUTHORITY,
        client_id: environment.NX_TVM_OIDC_CLIENT_ID,
        scope: environment.NX_TVM_OIDC_SCOPES,
      };
  }
}

export function getOidcAppConfiguration(oidcContext: OidcContext): OidcAppConfiguration {
  return {
    pathAuthorize: prefixOidcPath(oidcContext, OidcPath.AUTHORIZE),
    pathLogin: prefixOidcPath(oidcContext, OidcPath.LOGIN),
    pathLogout: prefixOidcPath(oidcContext, OidcPath.LOGOUT),
    oidcContext,
  };
}

export function getOidcConfigurationForContext(oidcContext: OidcContext): OidcConfiguration {
  return getOidcConfiguration(getIdpConfiguration(oidcContext), getOidcAppConfiguration(oidcContext));
}

export function getOidcConfiguration(idpConfiguration: IdpConfiguration, oidcAppConfiguration: OidcAppConfiguration): OidcConfiguration {
  const silent = supportsSilentFlow(oidcAppConfiguration.oidcContext);
  return {
    authority: idpConfiguration.authority,
    client_id: idpConfiguration.client_id,
    redirect_uri: createRedirectUri(oidcAppConfiguration.pathAuthorize),
    silent_login_uri: silent ? createRedirectUri(oidcAppConfiguration.pathLogin) : undefined,
    silent_redirect_uri: silent ? createRedirectUri(oidcAppConfiguration.pathAuthorize) : undefined,
    scope: idpConfiguration.scope,
    storage: localStorage,
  };
}

function prefixOidcPath(context: OidcContext, path: OidcPath): string {
  return context === OidcContext.DEFAULT ? `/${path}` : `/${context}/${path}`;
}

function supportsSilentFlow(oidcContext: OidcContext): boolean {
  return oidcContext !== OidcContext.DEFAULT;
}
